import { render, staticRenderFns } from "./XoaNguoiDungModal.vue?vue&type=template&id=18502211&"
import script from "./XoaNguoiDungModal.vue?vue&type=script&lang=js&"
export * from "./XoaNguoiDungModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports